import React, { useEffect, useState } from "react";
import util from "../../utils/miniUtils";

import MaterialTable from "@material-table/core";
import { ThemeProvider } from "@mui/material/styles";
import UserProfile from "./UserProfile";
import { ADD_USER, ADMIN_EMAIL, EDIT_USER } from "../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useWindowResize } from "../../utils/useWindowResize";

export default function Users() {

    const [users, setUsers] = useState( [] );
    const [showProfile, setShowProfile] = useState( false );
    const [user_id, setUserId] = useState( null );
    const [userAction, setUserAction] = useState( ADD_USER );
    const [loading, setLoading] = useState( false );
    const startLoading = () => setLoading( true );
    const stopLoading = () => setLoading( false );
    const { height } = useWindowResize();
    const [showAlert, setShowAlert] = useState( {
        delete: false,
        reactivate: false,
        forceDelete: false,
        duplicate: false
    } );
    const MySwal = withReactContent( Swal );
    useEffect( () => {
        getUsersList().then( null );
    }, [] );



    async function getUsersList() {
        try {
            startLoading();
            const request = await util.axios.get( `users/list` );
            let { error, msg, data } = request.data;
            if ( error ) throw msg;
            stopLoading();
            setUsers( data );
        } catch ( e ) {
            stopLoading();
            util.handleError( e );
        }
    }

    async function deleteUser() {
        try {
            startLoading();
            const request = await util.axios.delete( `users/${user_id}` );
            let { error, msg } = request.data;
            if ( error ) throw msg;
            stopLoading();
            util.toast().success( msg );
            await getUsersList();
        } catch ( e ) {
            stopLoading();
            util.handleError( e );
        }
    }

    async function forceDeleteUser() {
        try {
            startLoading();
            const request = await util.axios.delete( `users/force-delete/${user_id}` );
            let { error, msg } = request.data;
            if ( error ) throw msg;
            stopLoading();
            util.toast().success( msg );
            await getUsersList();
        } catch ( e ) {
            stopLoading();
            util.handleError( e );
        }
    }

    async function reactivateUser() {
        try {
            startLoading();
            const request = await util.axios.get( `users/reactivate-user/${user_id}` );
            let { error, msg } = request.data;
            if ( error ) throw msg;
            stopLoading();
            util.toast().success( msg );
            await getUsersList();
        } catch ( e ) {
            stopLoading();
            util.handleError( e );
        }
    }

    // SweetAlert2 for delete user (Deactivate)
    useEffect( () => {
        if ( showAlert.delete ) {
            MySwal.fire( {
                icon: 'warning',
                title: '⚠️ Desactivar Usuario',
                html: '<p>El usuario <strong>no podrá acceder</strong> al sistema.</p><p>Podrás reactivarlo más adelante.</p>',
                showCancelButton: true,
                confirmButtonText: 'Sí, desactivar usuario',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-warning',
                    cancelButton: 'btn btn-secondary'
                },
                buttonsStyling: false
            } ).then( ( result ) => {
                setShowAlert( { ...showAlert, delete: false } );
                if ( result.isConfirmed ) {
                    deleteUser();
                }
            } );
        }
    }, [ showAlert.delete ] );

    // SweetAlert2 for reactivate user
    useEffect( () => {
        if ( showAlert.reactivate ) {
            MySwal.fire( {
                icon: 'info',
                title: '✅ Reactivar Usuario',
                html: '<p>El usuario <strong>podrá acceder</strong> nuevamente al sistema.</p><p>Recuperará todos sus permisos y accesos.</p>',
                showCancelButton: true,
                confirmButtonText: 'Sí, reactivar usuario',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-secondary'
                },
                buttonsStyling: false
            } ).then( ( result ) => {
                setShowAlert( { ...showAlert, reactivate: false } );
                if ( result.isConfirmed ) {
                    reactivateUser();
                }
            } );
        }
    }, [ showAlert.reactivate ] );

    // SweetAlert2 for force delete user
    useEffect( () => {
        if ( showAlert.forceDelete ) {
            MySwal.fire( {
                icon: 'error',
                title: '🗑️ Eliminar Usuario Permanentemente',
                html: '<p><strong>Esta acción NO se puede deshacer.</strong></p><p>El usuario será <strong>eliminado completamente</strong> de la base de datos.</p><p>Todos sus datos y registros asociados serán removidos.</p>',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar permanentemente',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-secondary'
                },
                buttonsStyling: false
            } ).then( ( result ) => {
                setShowAlert( { ...showAlert, forceDelete: false } );
                if ( result.isConfirmed ) {
                    forceDeleteUser();
                }
            } );
        }
    }, [ showAlert.forceDelete ] );

    return (
        <div className="container-fluid mb-3 mt-3">

            <div className="row">
                <div className="col-md-12">
                    <ThemeProvider theme={util.defaultTableThemeSlim}>
                        <MaterialTable
                            title="Basic Search Preview"
                            columns={[
                                {
                                    title: 'Nombre', field: 'name',
                                    render: data => {
                                        if ( data.email === ADMIN_EMAIL ) return <b>{data.name}</b>;
                                        return (
                                            <span
                                                onClick={() => {
                                                    setUserAction( EDIT_USER );
                                                    setUserId( data.id );
                                                    setShowProfile( true );
                                                }}
                                                className="likeLink">
                                                {data.name}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Correo', field: 'email',
                                    render: data => {
                                        if ( data.email === ADMIN_EMAIL ) {
                                            return <b>{data.email}</b>;
                                        } else {
                                            return data.email;
                                        }
                                    }
                                },
                                {
                                    title: 'Teléfono', field: 'phone',
                                    render: data => {
                                        if ( data.email === ADMIN_EMAIL ) return "";
                                        return <a href={`tel:${data.phone}`}>{data.phone}</a>;
                                    }
                                },
                                {
                                    title: 'Rol', field: 'role',
                                    render: data => {
                                        if ( data.email === ADMIN_EMAIL ) {
                                            return <b>Root Administrator</b>;
                                        } else {
                                            return util.userRole( data.role );
                                        }

                                    }
                                },
                                {
                                    title: 'Status', field: 'status',
                                    render: data => {
                                        if ( data.email === ADMIN_EMAIL ) {
                                            return <b>Permanente</b>;
                                        } else {
                                            return util.userStatus( data.status );
                                        }

                                    }
                                },
                                {
                                    title: '', render: data => {
                                        if ( data.email === ADMIN_EMAIL ) return "";
                                        if ( data.status === 0 ) {
                                            return (
                                                <button onClick={() => {
                                                    setUserId( data.id );
                                                    setShowAlert( { ...showAlert, reactivate: true } );
                                                }} className="btn btn-sm btn-info">
                                                    <FontAwesomeIcon icon={faTimesCircle} />
                                                    <span className="p-2">Reactivar</span>
                                                </button>
                                            );
                                        }
                                        
                                        // Si puede ser eliminado, mostrar 2 botones
                                        if ( data.canDelete ) {
                                            return (
                                                <div className="d-flex gap-2">
                                                    <button 
                                                        onClick={() => {
                                                            setUserId( data.id );
                                                            setShowAlert( { ...showAlert, delete: true } );
                                                        }} 
                                                        className="btn btn-sm btn-warning"
                                                        title="Desactivar usuario: No podrá acceder al sistema, pero podrá ser reactivado"
                                                    >
                                                        <FontAwesomeIcon icon={faTimesCircle} size="xs" />
                                                        <span className="ms-2">Desactivar</span>
                                                    </button>
                                                    <button 
                                                        onClick={() => {
                                                            setUserId( data.id );
                                                            setShowAlert( { ...showAlert, forceDelete: true } );
                                                        }} 
                                                        className="btn btn-sm btn-danger"
                                                        title="Eliminar usuario: Eliminará permanentemente de la base de datos"
                                                    >
                                                        <FontAwesomeIcon icon={faTimesCircle} size="xs" />
                                                        <span className="ms-2">Eliminar</span>
                                                    </button>
                                                </div>
                                            );
                                        }
                                        
                                        // Si no puede ser eliminado, solo mostrar desactivar
                                        return (
                                            <button 
                                                onClick={() => {
                                                    setUserId( data.id );
                                                    setShowAlert( { ...showAlert, delete: true } );
                                                }} 
                                                className="btn btn-sm btn-info"
                                                title="Desactivar usuario: No podrá acceder al sistema, pero podrá ser reactivado"
                                            >
                                                <FontAwesomeIcon icon={faTimesCircle} size="xs" />
                                                <span className="ms-2">Desactivar</span>
                                            </button>
                                        );
                                    }
                                },
                            ]}
                            data={users}
                            options={{
                                toolbarButtonAlignment: "left",
                                showTitle: false,
                                paginationPosition: "both",
                                columnsButton: true,
                                pageSize: 10,
                                searchFieldAlignment: "left",
                                emptyRowsWhenPaging: true,
                                padding: "dense",
                                showTextRowsSelected: false,
                                headerStyle: { position: 'sticky', top: 0 }, 
                                maxBodyHeight: height - 300
                            }}
                            actions={[
                                {
                                    icon: () => (
                                        <div className={'btn btn-primary btn-sm'}>
                                            <FontAwesomeIcon
                                                icon={faPlusCircle}
                                                className="mr-3"
                                            />
                                            <span className="p-2">Crear Usuario</span>
                                        </div>
                                    ),
                                    tooltip: 'Crear nuevo usuario',
                                    isFreeAction: true,
                                    onClick: () => {
                                        setUserAction( ADD_USER );
                                        setShowProfile( true );
                                    }
                                },
                            ]}
                        />
                    </ThemeProvider>
                </div>
            </div>

            {
                showProfile ?
                    <UserProfile
                        user_id={user_id}
                        show={showProfile}
                        handleClose={() => setShowProfile( false )}
                        reloadTable={getUsersList}
                        action={userAction}
                    />
                    :
                    null
            }


            {/* SweetAlert2 dialogs handled by useEffect hooks */}
            {util.LOADING_SCREEN( loading )}
        </div>
    );
}